<script setup>
import BaseModal from "../global/modals/BaseModal.vue";
import TwoFactorChallenge from "./TwoFactorChallenge.vue";
import {ref} from "vue";

const emit = defineEmits(['close', 'confirm']);

const tfaConfirmed = ref(false);

</script>

<template>
  <Teleport to="body">
    <BaseModal
      id="regenerate-codes-modal"
      @close="emit('close')"
    >
      <template #heading>
        Regenerate recovery codes?
      </template>

      <div>
        <TwoFactorChallenge
          v-if="!tfaConfirmed"
          :is-challenge="true"
          :isolated="true"
          @confirmed="tfaConfirmed = true"
          @failed="tfaConfirmed = false"
        >
          <p class="text-center">
            Please confirm your identity before regenerating your recovery codes.<br>
            You will need to store these recovery codes in a secure password manager.
          </p>
        </TwoFactorChallenge>

        <div
          v-else
          class="confirmed"
        >
          <svg-vue
            class="svg mr-0 mr-lg-2"
            icon="icons/tick-green"
          />

          <span>Thank you, identity confirmed.</span>
        </div>
      </div>

      <template #footer>
        <div class="w-100 d-flex justify-content-center m-0 m-auto">
          <button
            v-if="!tfaConfirmed"
            class="btn btn-danger btn-lg button font-weight-bold mx-3 mb-0 w-50"
            @click="emit('close')"
          >
            Cancel
          </button>
          <button
            class="btn btn-success btn-lg button font-weight-bold mx-3 mb-0 w-100"
            :class="{disabled: !tfaConfirmed}"
            :disabled="!tfaConfirmed"
            @click="emit('confirm')"
          >
            Regenerate Recovery Codes
          </button>
        </div>
      </template>
    </BaseModal>
  </Teleport>
</template>

<style>
  #regenerate-codes-modal .modal_window {
    max-width: 900px;
    min-width: 675px;
  }

  #regenerate-codes-modal .confirmed {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
  }

  #regenerate-codes-modal .confirmed svg {
    max-width: 100px;
  }

  #regenerate-codes-modal .confirmed span {
    font-size: 14px;
    margin-top: 10px;
  }

  #regenerate-codes-modal .btn-danger {
    background: #F34F4F;
  }
</style>
